import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { apiGetInvitations } from '../api/invitations/invitations';
import { AppThunk } from './index';

export interface InvitationsState {
  invitations: [];
  invitation: {} | null;
  isClientInvitationsLoading: boolean;
  isClientInvitationsRequested: boolean;
  isClientInvitationsSuccess: boolean;
}

const initialState: InvitationsState = {
  invitations: [],
  invitation: null,
  isClientInvitationsLoading: false,
  isClientInvitationsRequested: false,
  isClientInvitationsSuccess: false,
};

const invitationsStateSlice = createSlice({
  name: 'invitations',
  initialState,
  reducers: {
    clientInvitationsStart(state: InvitationsState) {
      state.isClientInvitationsRequested = false;
      state.isClientInvitationsLoading = true;
      state.isClientInvitationsSuccess = false;
    },
    clientInvitationsSuccess(
      state: InvitationsState,
      action: PayloadAction<[]>
    ) {
      state.invitations = action ? action.payload : [];
      state.isClientInvitationsRequested = true;
      state.isClientInvitationsLoading = false;
      state.isClientInvitationsSuccess = true;
    },
    clientInvitationsFailed(state: InvitationsState) {
      state.isClientInvitationsRequested = true;
      state.isClientInvitationsLoading = false;
      state.isClientInvitationsSuccess = false;
    },
    setClientInvitation(
      state: InvitationsState,
      action: PayloadAction<{} | null>
    ) {
      state.invitation = action ? action.payload : null;
      state.isClientInvitationsRequested = false;
      state.isClientInvitationsLoading = false;
      state.isClientInvitationsSuccess = false;
    },
  },
});

export const {
  clientInvitationsStart,
  clientInvitationsSuccess,
  clientInvitationsFailed,
  setClientInvitation,
} = invitationsStateSlice.actions;

export default invitationsStateSlice.reducer;

export const getInvitations = (): AppThunk => async (dispatch) => {
  try {
    dispatch(clientInvitationsStart());
    const companyData = await apiGetInvitations();

    dispatch(clientInvitationsSuccess(companyData));
  } catch (err) {
    console.error(err.toString());
    dispatch(clientInvitationsFailed());
  }
};
